import { $ } from "@/common/Axios";

export default {
  /**
   * 职教配置
   */
  continueConfig: {
    /*
     * 添加
     * content 内容 (string query )
     * id  (integer query )
     * siteId 学校id (integer query )
     * type 类型：学院、批次、所属方向、岗位方向、课程类别、习题标签、习题难度 (string query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueConfig", p, c),

    /*
     * 删除,数量等于0可删
     * id id (string query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueConfig", p, c),
  },
  continueConfig_listBatch: {
    /*
     * 批次列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueConfig/listBatch", p, c),
  },
  continueConfig_listBatchName: {
    /*
     * 批次名称列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueConfig/listBatchName", p, c),
  },
  continueConfig_listCourseCategory: {
    /*
     * 课程类别列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listCourseCategory", p, c),
  },
  continueConfig_listCourseCategoryName: {
    /*
     * 课程类别名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listCourseCategoryName", p, c),
  },
  continueConfig_listCourseDirection: {
    /*
     * 课程方向列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listCourseDirection", p, c),
  },
  continueConfig_listCourseDirectionName: {
    /*
     * 课程方向名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listCourseDirectionName", p, c),
  },
  continueConfig_listPostDirection: {
    /*
     * 岗位方向列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listPostDirection", p, c),
  },
  continueConfig_listPostDirectionName: {
    /*
     * 岗位方向名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listPostDirectionName", p, c),
  },
  continueConfig_listSchool: {
    /*
     * 学院列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueConfig/listSchool", p, c),
  },
  continueConfig_listSchoolName: {
    /*
     * 学院名称列表
     * siteId 学校id (integer query )
     */
    get: (p, c) => $.get("/api/bms/cont/continueConfig/listSchoolName", p, c),
  },
  continueConfig_listSubjectDifficulty: {
    /*
     * 习题难度列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listSubjectDifficulty", p, c),
  },
  continueConfig_listSubjectDifficultyName: {
    /*
     * 习题难度名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listSubjectDifficultyName", p, c),
  },
  continueConfig_listSubjectLabel: {
    /*
     * 习题标签列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueConfig/listSubjectLabel", p, c),
  },
  continueConfig_listSubjectLabelName: {
    /*
     * 习题标签名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueConfig/listSubjectLabelName", p, c),
  },
  continueConfig_syncBySite: {
    /*
     * 一键迁移
     * originSiteId originSiteId (integer query required)
     * targetSiteId targetSiteId (integer query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueConfig/syncBySite", p, c),
  },
  continueConfig_syncConfig: {
    /*
     * 同步配置
     */
    post: (p, c) => $.post("/api/bms/cont/continueConfig/syncConfig", p, c),
  },

  /**
   * 职教课程
   */
  continueCourse: {
    /*
     * 添加
     * categories 课程类别，多选 (string query required)
     * cover 封面 (string query required)
     * directions 课程方向，多选 (string query required)
     * extraFileUrl 教学附件 (string query required)
     * id id (integer query )
     * intro 课程介绍 (string query required)
     * name 课程名称 (string query required)
     * postDirections 岗位方向，多选 (string query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueCourse", p, c),

    /*
     * 删除, 教学计划数量等于0可删
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueCourse", p, c),
  },
  continueCourse_able: {
    /*
     * 启用禁用
     * ableStatus 启用状态 (string query required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueCourse/able", p, c),
  },
  continueCourse_list: {
    /*
     * 课程列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueCourse/list", p, c),
  },
  continueCourse_listSimple: {
    /*
     * 简易课程列表
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) => $.get("/api/bms/cont/continueCourse/listSimple", p, c),
  },

  /**
   * 职教课程大章小节
   */
  continueCourseChapter: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query required)
     * courseId courseId (integer query required)
     * id id (integer query )
     * name 名称 (string query required)
     * sorting 排序(5位数以内) (integer query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueCourseChapter", p, c),

    /*
     * 删除, 小节数量等于0可删
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueCourseChapter", p, c),
  },
  continueCourseChapter_batchAddSection: {
    /*
     * 批量添加小节
     * chapterId 大章ID (integer query required)
     * sections 小节名称列表，半角逗号隔开 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueCourseChapter/batchAddSection", p, c),
  },
  continueCourseChapter_list: {
    /*
     * 课程列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueCourseChapter/list", p, c),
  },
  continueCourseChapter_listSection: {
    /*
     * 小节列表
     * ableStatus 启用禁用 (string query )
     * chapterId 大章ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueCourseChapter/listSection", p, c),
  },
  continueCourseChapter_listSimple: {
    /*
     * 简易大章列表
     * ableStatus 启用禁用 (string query )
     * courseId courseId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueCourseChapter/listSimple", p, c),
  },
  continueCourseChapter_removeSection: {
    /*
     * 删除小节
     * ids 小节列表Ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/cont/continueCourseChapter/removeSection", p, c),
  },
  continueCourseChapter_saveSection: {
    /*
     * 添加编辑小节
     * ableStatus 启用状态 (string query )
     * chapterId 大章d (integer query )
     * docUrl 文档资料地址 (string query )
     * duration 视频时长 (integer query )
     * id  (integer query )
     * name 名字 (string query )
     * sorting 排序 (integer query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueCourseChapter/saveSection", p, c),
  },

  /**
   * 拓展课程
   */
  continueExtension_exportKnowledge: {
    /*
     * 导出知识点列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueExtension/exportKnowledge", p, c),
  },
  continueExtension_listCourse: {
    /*
     * 课程列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueExtension/listCourse", p, c),
  },
  continueExtension_listCourseForClient: {
    /*
     * c端拓展课程列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueExtension/listCourseForClient", p, c),
  },
  continueExtension_listKnowledge: {
    /*
     * 知识点列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueExtension/listKnowledge", p, c),
  },
  continueExtension_listKnowledgeForClient: {
    /*
     * c端拓展知识点列表
     * courseId courseId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueExtension/listKnowledgeForClient", p, c),
  },
  continueExtension_listSimpleCourse: {
    /*
     * 简易课程列表
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueExtension/listSimpleCourse", p, c),
  },
  continueExtension_removeCourse: {
    /*
     * 删除课程, 知识点数量为0才可删
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/cont/continueExtension/removeCourse", p, c),
  },
  continueExtension_removeKnowledge: {
    /*
     * 删除知识点
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/cont/continueExtension/removeKnowledge", p, c),
  },
  continueExtension_saveCourse: {
    /*
     * 添加课程
     * ableStatus 启用状态 (string query )
     * cover 封面 (string query )
     * id  (integer query )
     * intro 课程简介 (string query )
     * name 课程名字 (string query )
     * siteId 学校id (integer query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueExtension/saveCourse", p, c),
  },
  continueExtension_saveKnowledge: {
    /*
     * 添加知识点
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * duration 时长(秒) (integer query )
     * id  (integer query )
     * name 课程名字 (string query )
     * sorting  (integer query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueExtension/saveKnowledge", p, c),
  },
  continueExtension_upload: {
    /*
     * 导入知识点
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueExtension/upload", p, c),
  },

  /**
   * 职教试卷
   */
  continuePaper: {
    /*
     * 添加（自己组卷，从题库中选题， 注意belongId为授课安排ID，需下拉选择）
     * ableStatus 启用状态：启用，禁用 (string query )
     * belongId 归属id，授课安排id (integer query )
     * content 内容 (string query )
     * duration 建议答题时长 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * subjectCount 习题数量 (integer query )
     * type 类型:课程作业、独立试卷 (string query )
     */
    post: (p, c) => $.post("/api/bms/cont/continuePaper", p, c),

    /*
     * 删除，完成数量为0方可删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continuePaper", p, c),
  },
  continuePaper_autoGenerate: {
    /*
     * 自动生成
     * content 题目类型组合JSON， name=题型， totalScore=分值 (undefined body required)
     * duration 建议答题时长 (string query required)
     * name 试卷名称 (string query required)
     * teachingPlanId 授课安排ID (integer query required)
     * type 类型：课程作业，独立试卷 (string query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continuePaper/autoGenerate", p, c),
  },
  continuePaper_batchAble: {
    /*
     * 批量启用禁用
     * ableStatus 启用禁用 (string query required)
     * ids ids (array query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continuePaper/batchAble", p, c),
  },
  continuePaper_content: {
    /*
     * 预览试卷
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/cont/continuePaper/content", p, c),
  },
  continuePaper_listForExam: {
    /*
     * 独立试卷列表
     */
    get: (p, c) => $.get("/api/bms/cont/continuePaper/listForExam", p, c),
  },
  continuePaper_listForWork: {
    /*
     * 课程作业列表
     */
    get: (p, c) => $.get("/api/bms/cont/continuePaper/listForWork", p, c),
  },
  continuePaper_listSimple: {
    /*
     * 简易试卷列表
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * teachingPlanId 授课安排ID (integer query )
     * type 类型:课程作业|独立试卷 (string query )
     */
    get: (p, c) => $.get("/api/bms/cont/continuePaper/listSimple", p, c),
  },

  /**
   * AI问答
   */
  continueQuestionAnswer: {
    /*
     * 添加
     * answer 答案 (string query )
     * creatorId  (integer query )
     * id  (integer query )
     * question 问题 (string query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueQuestionAnswer", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueQuestionAnswer", p, c),
  },
  continueQuestionAnswer_getMinSimilarity: {
    /*
     * 获取最低相似度阈值
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueQuestionAnswer/getMinSimilarity", p, c),
  },
  continueQuestionAnswer_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueQuestionAnswer/list", p, c),
  },
  continueQuestionAnswer_question: {
    /*
 * 提问
* minSimilarity 阈值，0.8-1.0: 非常严格匹配，只接受高度相似的问题
0.6-0.8: 中等严格匹配，接受较为相似的问题
0.4-0.6: 宽松匹配，接受有一定相关性的问题
0.0-0.4: 非常宽松匹配，大多数问题都能匹配上 (number query )
* question 问题内容 (string query required)
*/
    get: (p, c) => $.get("/api/bms/cont/continueQuestionAnswer/question", p, c),
  },
  continueQuestionAnswer_savMinSimilarity: {
    /*
 * 配置最低相似度阈值
* minSimilarity 阈值，0.8-1.0: 非常严格匹配，只接受高度相似的问题
0.6-0.8: 中等严格匹配，接受较为相似的问题
0.4-0.6: 宽松匹配，接受有一定相关性的问题
0.0-0.4: 非常宽松匹配，大多数问题都能匹配上 (number query )
*/
    post: (p, c) =>
      $.post("/api/bms/cont/continueQuestionAnswer/savMinSimilarity", p, c),
  },

  /**
   * 职教分享资源
   */
  continueResource: {
    /*
     * 添加编辑-操作自己的
     * ableStatus 启用状态 (string query )
     * cover 封面 (string query )
     * creatorId 创建人 (integer query )
     * downloadCount 下载数量 (integer query )
     * fileUrl 附件地址 (string query )
     * id  (integer query )
     * intro 介绍 (string query )
     * name 名称 (string query )
     * siteId 学校id (integer query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueResource", p, c),

    /*
     * 删除, 仅删除自己的
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueResource", p, c),
  },
  continueResource_batchAble: {
    /*
     * 批量启用禁用，无需是自己的，有权限即可操作所以
     * ableStatus 启用禁用 (string query required)
     * ids ids (array query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueResource/batchAble", p, c),
  },
  continueResource_downloadForClient: {
    /*
     * c端下载前来调用下，下载量加1
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueResource/downloadForClient", p, c),
  },
  continueResource_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueResource/list", p, c),
  },
  continueResource_listForClient: {
    /*
     * c端资源广场列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueResource/listForClient", p, c),
  },

  /**
   * 职教学生练习记录
   */
  continueStudentExercise_commitForClient: {
    /*
     * 交卷(返回练习id)
     * answerContent 答案Json (string query required)
     * belongId belongId, 列表返回的或练习信息返回的 (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * paperId 试卷id (integer query required)
     * type 类型：课程作业，独立试卷 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueStudentExercise/commitForClient", p, c),
  },
  continueStudentExercise_exportForExam: {
    /*
     * 独立试卷记录导出
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/exportForExam", p, c),
  },
  continueStudentExercise_exportForWork: {
    /*
     * 课程作业记录导出
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/exportForWork", p, c),
  },
  continueStudentExercise_listExamForClient: {
    /*
     * 独立试卷列表-c端
     * courseId 课程ID, 从授课安排,c端我的简易课程列表 (integer query )
     * status 状态:已完成未完成 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/listExamForClient", p, c),
  },
  continueStudentExercise_listForExam: {
    /*
     * 独立试卷记录列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/listForExam", p, c),
  },
  continueStudentExercise_listForWork: {
    /*
     * 课程作业记录列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/listForWork", p, c),
  },
  continueStudentExercise_listWorkForClient: {
    /*
     * 课程作业列表-c端
     * courseId 课程ID, 从授课安排,c端我的简易课程列表 (integer query )
     * status 状态:已完成未完成 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentExercise/listWorkForClient", p, c),
  },
  continueStudentExercise_read: {
    /*
     * 阅卷
     * id 练习id (integer query required)
     * scores 分数 (array query required)
     * subjectIds 题目id (array query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueStudentExercise/read", p, c),
  },
  continueStudentExercise_redo: {
    /*
     * 打回重做
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueStudentExercise/redo", p, c),
  },

  /**
   * 职教平台学生提问
   */
  continueStudentQuestion_answer: {
    /*
     * 回复
     * attachment 问题附件 (string query )
     * content 回复内容 (string query required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueStudentQuestion/answer", p, c),
  },
  continueStudentQuestion_askForClient: {
    /*
     * C端提问
     * attachment 问题附件 (string query )
     * content 问题内容 (string query required)
     * parentId 父级问题ID (integer query )
     * teachingPlanId 课程id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueStudentQuestion/askForClient", p, c),
  },
  continueStudentQuestion_list: {
    /*
     * list
     */
    get: (p, c) => $.get("/api/bms/cont/continueStudentQuestion/list", p, c),
  },
  continueStudentQuestion_listForClient: {
    /*
     * listForClient
     * teachingPlanId 课程id (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueStudentQuestion/listForClient", p, c),
  },
  continueStudentQuestion_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/cont/continueStudentQuestion/remove", p, c),
  },

  /**
   * 职教学生视频
   */
  continueStudentVideo_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/cont/continueStudentVideo/export", p, c),
  },
  continueStudentVideo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueStudentVideo/list", p, c),
  },
  continueStudentVideo_progressForClient: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME等情况调用，学习1分钟
     * progress 进度 (integer query required)
     * sectionId 小节id (integer query required)
     * teachingPlanId 课程详情返回的id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/cont/continueStudentVideo/progressForClient", p, c),
  },

  /**
   * 职教习题
   */
  continueSubject: {
    /*
     * 编辑习题
     * ableStatus 启用状态 (string query )
     * analysis 解析 (string query )
     * answer 答案 (string query )
     * answerA 选项A (string query )
     * answerB 选项B (string query )
     * answerC 选项C (string query )
     * answerD 选项D (string query )
     * answerE 选项E (string query )
     * answerF 选项F (string query )
     * content 题目 (string query required)
     * contentContent 题干 (string query )
     * id id (integer query required)
     * labels 习题标签，多选逗号隔开 (string query )
     * level 难度 (string query )
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/bms/cont/continueSubject", p, c),
  },
  continueSubject_exerciseInfo: {
    /*
     * 练习信息
     * paperId 试卷id (integer query required)
     * studentExerciseId 练习id，有做题记录的 (integer query )
     * type 类型：课程作业、独立试卷 (string query required)
     */
    get: (p, c) => $.get("/api/bms/cont/continueSubject/exerciseInfo", p, c),
  },
  continueSubject_exerciseInfoForClient: {
    /*
     * C端练习信息
     * exerciseId 练习id (integer query )
     * paperId 试卷id (integer query required)
     * type 类型：课程作业、独立试卷 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueSubject/exerciseInfoForClient", p, c),
  },
  continueSubject_export: {
    /*
     * 导出习题
     */
    get: (p, c) => $.get("/api/bms/cont/continueSubject/export", p, c),
  },
  continueSubject_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueSubject/list", p, c),
  },
  continueSubject_listSimplePage: {
    /*
     * 简易列表，组卷选题用
     * chapterIds 大章ID列表 (array query )
     * content 题目 (string query )
     * contentType 内容类型 (string query )
     * courseId 课程ID (integer query required)
     * labels 习题标签 (string query )
     * logicType 逻辑类型 (string query )
     */
    get: (p, c) => $.get("/api/bms/cont/continueSubject/listSimplePage", p, c),
  },
  continueSubject_uploadByExcel: {
    /*
     * 上传章节习题(Excel)
     * courseId 课程id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueSubject/uploadByExcel", p, c),
  },

  /**
   * 职教老师
   */
  continueTeacher: {
    /*
     * 添加
     * id id (integer query )
     * name 姓名 (string query )
     * phone 手机号 (string query )
     * school 学院 (string query )
     * siteId 学校id (integer query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueTeacher", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueTeacher", p, c),
  },
  continueTeacher_exportForHeaderTeacher: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeacher/exportForHeaderTeacher", p, c),
  },
  continueTeacher_exportForTeacher: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeacher/exportForTeacher", p, c),
  },
  continueTeacher_listForHeaderTeacher: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeacher/listForHeaderTeacher", p, c),
  },
  continueTeacher_listForTeacher: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueTeacher/listForTeacher", p, c),
  },
  continueTeacher_listSimpleForHeaderTeacher: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeacher/listSimpleForHeaderTeacher", p, c),
  },
  continueTeacher_listSimpleForTeacher: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeacher/listSimpleForTeacher", p, c),
  },
  continueTeacher_syncTeacher: {
    /*
     * 同步讲师和班主任
     */
    post: (p, c) => $.post("/api/bms/cont/continueTeacher/syncTeacher", p, c),
  },
  continueTeacher_uploadForHeaderTeacher: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueTeacher/uploadForHeaderTeacher", p, c),
  },
  continueTeacher_uploadForTeacher: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/cont/continueTeacher/uploadForTeacher", p, c),
  },

  /**
   * 职教授课安排
   */
  continueTeachingPlan: {
    /*
     * 添加
     * classroomId 班级id (integer query )
     * courseId 课程id (integer query )
     * id  (integer query )
     * outline 课程大纲 (string query )
     * teacherId 授课老师 (integer query )
     * term 学期 (integer query )
     */
    post: (p, c) => $.post("/api/bms/cont/continueTeachingPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/cont/continueTeachingPlan", p, c),
  },
  continueTeachingPlan_detailsForClient: {
    /*
     * 课程详情-c端
     * id 课程列表返回的id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeachingPlan/detailsForClient", p, c),
  },
  continueTeachingPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/cont/continueTeachingPlan/export", p, c),
  },
  continueTeachingPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/cont/continueTeachingPlan/list", p, c),
  },
  continueTeachingPlan_listForClient: {
    /*
     * 我的课程列表-c端
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeachingPlan/listForClient", p, c),
  },
  continueTeachingPlan_listSimpleByParams: {
    /*
     * 根据班级和学期，查询简易授课安排列表，返回的id为授课安排ID
     * classroomId 班级 (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeachingPlan/listSimpleByParams", p, c),
  },
  continueTeachingPlan_listSimpleClassroom: {
    /*
     * 根据班级和学期，查询简易授课安排列表，返回的id为授课安排ID
     * batch batch (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeachingPlan/listSimpleClassroom", p, c),
  },
  continueTeachingPlan_listSimpleForClient: {
    /*
     * 我的简易课程列表-c端
     */
    get: (p, c) =>
      $.get("/api/bms/cont/continueTeachingPlan/listSimpleForClient", p, c),
  },
  continueTeachingPlan_upload: {
    /*
     * 批量导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/cont/continueTeachingPlan/upload", p, c),
  },
};
